import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Routes, Route, useNavigate } from 'react-router-dom'
import NotificationsLst from './NotificationsLst'
import { useStores } from '../../../cls/stores/MobXProvider'
import { useSmartTranslation } from '../../../cls/TranslationContext'
/**
 * @function NotificationsMain
 * @description Main component for the notifications module. Sets up routing and permission checks.
 */

const NotificationsMain = () => {
	const navigate = useNavigate()
	const { users } = useStores()
	const { loggedInUserId, loggedInUser } = users
	const isAdmin = loggedInUser?.isAdmin
	const isSuperAdmin = loggedInUser?.isSuperAdmin
	const { t } = useSmartTranslation()

	useEffect(() => {
		if (!users.isLoggedIn) {
			navigate('/logout')
			return
		}
	}, [loggedInUserId])

	// If the user does not have personal permission
	// and lacks the required permissions for the action and resource
	// Display a message indicating lack of permissions
	if (!(isAdmin || isSuperAdmin || users.canUser('read', 'notifications'))) {
		return (
			<div style={{ textAlign: 'center' }}>
				{t('__denied.access').charAt(0).toUpperCase() +
					t('__denied.access%__feature-off%_notification')
						.toLowerCase()
						.slice(1)}
			</div>
		)
	}

	return (
		<Routes>
			<Route index element={<NotificationsLst />} />
			<Route path="*" element={<div>Not found</div>} />
		</Routes>
	)
}
export default observer(NotificationsMain)
